module.exports = "/_next/static/images/id-1cfe41605519ecf1c766a6abfe02239b.svg";